import React from "react";
import { PostLogin } from "../component/Header";
import BroadcastContent from "./BroadcastContent";
import { useRequireRBAC } from "../component/shared/useRequireRBAC";
import { PERMISSION_KEY } from "../types/Rbac/permission";

function Broadcast() {
  useRequireRBAC([PERMISSION_KEY.broadcastView]);

  return (
    <div className={`post-login`}>
      <PostLogin selectedItem={"Campaigns"} />
      <BroadcastContent />
    </div>
  );
}

export default Broadcast;
